import type {LayoutPart, LayoutRowPartWidth} from 'shared/layouts';

export class LayoutBuilderUtil {

    public static createRow(rowWidth: LayoutRowPartWidth, columnRatios: number[], parts: LayoutPart[]): LayoutPart {
        return {
            type: 'row',
            props: {
                rowWidth,
                columnRatios
            },
            parts
        }
    }

    public static createColumn(isAside: boolean, parts: LayoutPart[]): LayoutPart {
        return {
            type: 'column',
            props: {
                isAside
            },
            parts
        }
    }

    public static createComponent(componentName: string): LayoutPart {
        return {
            type: 'component',
            componentName
        }
    }

    public static createInRowComponent(rowWidth: LayoutRowPartWidth, componentName: string): LayoutPart {
        return this.createRow(rowWidth, [1], [this.createColumn(false, [this.createComponent(componentName)])]);
    }
}